export default __webpack_public_path__ + "static/media/download (3).1cf84960.svg";